export default "__VITE_ASSET__DwV11Jfc__"